import { EpicIcons, TooltipPosition } from "@constellation-academy/epic-ui";
import React from "react";
import { useFragment } from "react-relay";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useTranslation } from "@i18n/hooks";
import { type editCourseLearnableButton_UnpublishedLearnableFragment$key } from "@relay/editCourseLearnableButton_UnpublishedLearnableFragment.graphql";
import { UNPUBLISHED_LEARNABLE_FRAGMENT } from "./edit-course-learnable-button.graphql";
import { type EditCourseLearnableButtonProps } from "./edit-course-learnable-button.types";
import { Button, ButtonVariant } from "../../../../components/button";
import { Paths } from "../../../../routes/paths";

export const EditCourseLearnableButton = ({
	learnableFragmentRef,
}: EditCourseLearnableButtonProps) => {
	const offer = useFragment<editCourseLearnableButton_UnpublishedLearnableFragment$key>(
		UNPUBLISHED_LEARNABLE_FRAGMENT,
		learnableFragmentRef,
	);
	const { t } = useTranslation("common");
	const navigate = useNavigate();
	const handleOnClick = () => {
		if (!offer?.root?.id) return toast.error(t("offers.missingRootId"));
		navigate(Paths.educationalOffer.withId(offer.root.id).path);
	};
	return (
		<Button
			variant={ButtonVariant.Default}
			icon={EpicIcons.PENCIL}
			tooltip={t("offers.edit")}
			position={TooltipPosition.Left}
			onClick={handleOnClick}
		/>
	);
};
